<template>
	<mm-tab-title v-model="tab" :titles="titles">
		<div slot="save" v-show="tab===1" >
			<el-button size="medium" type="primary" @click="submit">save</el-button>
		</div>
		<div>
		<div v-show="tab===1">
			<el-form ref="form" :model="result" size="small" label-width="200px">
				
					<el-form-item label="Adv Name" prop="adv_name"  required>
						<el-input v-model="result.adv_name" :readonly="edit" />
					</el-form-item>
					<el-form-item label="Status" prop="status" required>
						<el-radio-group v-model="result.status">
							<el-radio label='active'>active</el-radio>
							<el-radio label='pending'>pending</el-radio>
							<el-radio label='paused'>paused</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="Adv. Budget($)" prop="adv_budget"  required>
						<el-input type="number" @mousewheel.native.prevent v-model="result.adv_budget"/>
					</el-form-item>
					<el-form-item label="Adv. Offer Budget($)" prop="adv_offer_budget"  required>
						<el-input type="number" @mousewheel.native.prevent v-model="result.adv_offer_budget"/>
					</el-form-item>
					<el-form-item label="Offer CVR Rule" prop="offer_cvr_rule">
						<mm-adv-rule-offer-cvr-rule v-model="result.offer_cvr_rule" />
					</el-form-item>
					
			</el-form>
        </div>
		<div v-show="tab===2">
			<div class="add-rule">
				<mm-lc title="Channel">
					<mm-channel-select no_paused v-model="channel_ids" :filter_list="filter_list" multiple/>
				</mm-lc>
				<mm-lc title="Daily Cap">
					<el-input type="number" @mousewheel.native.prevent v-model="daily_cap" size="small"/>
				</mm-lc>
				<mm-lc title="Add Rule">
					<el-button type="primary" size="medium" @click="addRule">Create</el-button>
				</mm-lc>
			</div>
			<div class="rule-table">
			<mm-rule-list ref="rl" apiPath="/advChannelRule/list" :where="where" ruleType="adv"></mm-rule-list>
			</div>
		</div>
		</div>
	</mm-tab-title>

</template>

<script>
export default {
	props: ["edit"],
	watch:{
		'$route' (to, from) {
			this.loadData();
		}
	},
	data() {
		return {
			result: {
				is_api: true,
				status: 'active',
				jump_way: 2,
			},
			file_list:[],
			tab: 1,
			where: {
				adv_id:this.$route.query['id'],
				channel_id: ''
			},
			channel_ids:'',
			daily_cap:'',
			rule_arr:[],
			titles:['Basic Rule','Adv-Channel-Rule'],
			filter_list: [],
		};
	},
	methods: {
		async submit() {
			await this.$validate(this.$refs.form);
			const result = await this.$post('/advertiserRule/update',this.result);
			this.$router.push({ path: "/advRuleEdit",query:{id:result} });
            
		},
		async loadData(){
			const id = this.$route.query['id'];
			this.result = await this.$post('/advertiserRule/detail',{adv_id:id});
		},
		async addRule(){
			if(this.channel_ids.length == 0 || this.daily_cap == 0){
				this.$message({
					type: 'error',
					message: 'type error',
				});
				return;
			}
			let channel = [];
			if(this.channel_ids.$nin != undefined){
				for (const channel_obj of this.$cache.channel_list) {
					if(this.channel_ids.$nin.indexOf(channel_obj.value) == -1){
						channel.push([channel_obj.value,channel_obj.name]);
					}
				}
			}else{
				for (const channel_obj of this.$cache.channel_list) {
					if(this.channel_ids.$in.indexOf(channel_obj.value) != -1){
						channel.push([channel_obj.value,channel_obj.name]);
					}
				}
			}
			

			const result = await this.$post('/advChannelRule/create',{adv_id:this.result.adv_id,adv_name:this.result.adv_name,channel:channel,daily_cap:this.daily_cap});

			this.$refs.rl.$children[0].refresh();
			// init data & channel select options
			this.channel_ids = '';
			this.daily_cap = '';
			await this.getAllId();
		},
		async getAllId(){
			const id = this.$route.query['id'];
			const result = await this.$post('/advChannelRule/getAllId',{where:{adv_id:id}});
			for(const row of result) {
				this.filter_list.push(row.channel_id);
			}
		},
	},
		
    
	beforeMount() {
		this.loadData();
		this.getAllId();
	}
};
</script>

<style scoped>
	.add-rule {
		display:flex;
		flex-direction: row;
	}
	.rule-table {
		width: 100%;
		height: 650px;
	}
</style>